import React from 'react'


import { CustomButton } from '@components/CustomButton'

import { ButtonContainer } from './styles'

interface IAddResourceButtonProps {
  onAddAssignment: () => void
  duration: number
}

export function AddResourceButton({
  duration,
  onAddAssignment,
}: IAddResourceButtonProps) {
  function addAssignment() {
    if (duration) {
      onAddAssignment()
    } else {
      showAlertForTaskDurationMissing()
    }
  }

  function showAlertForTaskDurationMissing() {
    window.alert(
      'A task duration must be entered before adding a resource',
    )
  }

  return (
    <ButtonContainer>
      <CustomButton onPress={addAssignment} secondary>
        Add Resource
      </CustomButton>
    </ButtonContainer>
  )
}
